import {
  faAngleRight,
  faPencilAlt,
  faTimes,
  faTrash,
  faMapMarkerAlt,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'components/base/Button';
import dayjs from 'dayjs';
import axios from 'axios';
import { useCalendarContext } from 'providers/CalendarProvider';
import { Modal } from 'react-bootstrap';
import { REMOVE_EVENT, SET_CALENDAR_STATE } from 'reducers/CalendarReducer';

const CalendarEventModal = () => {
  const { selectedEvent, calendarDispatch } = useCalendarContext();
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000';

  const handleRemove = async () => {
    if (!selectedEvent) return;
    
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar este evento?');
    if (!confirmDelete) return;

    try {
      // Borrar de la base de datos (corregido a la ruta estándar DELETE /eventos/:id)
      await axios.delete(`${apiUrl}/eventos/${selectedEvent.id}`);
      
      // Borrar del estado del calendario
      calendarDispatch({
        type: REMOVE_EVENT
      });
      handleClose();
    } catch (error) {
      console.error('Error al eliminar el evento:', error);
    }
  };

  const handleClose = () => {
    calendarDispatch({
      type: SET_CALENDAR_STATE,
      payload: {
        selectedEvent: null
      }
    });
  };

  // Función para abrir el modal de edición
  const handleEditClick = () => {
    calendarDispatch({
      type: SET_CALENDAR_STATE,
      payload: { 
        openNewEventModal: true // Abrimos el modal de formulario
        // NO ponemos selectedEvent en null aquí, así el modal de formulario sabe qué evento editar
      }
    });
  };

  const evtData = selectedEvent?.extendedProps;

  return (
    <Modal
      centered
      show={!!selectedEvent}
      onHide={handleClose}
      contentClassName="border"
    >
      <Modal.Header className="ps-card border-bottom border-translucent">
        <div>
          <Modal.Title className="modal-title text-body-highlight mb-0">
            {selectedEvent?.title}
          </Modal.Title>
          {evtData?.proc && (
            <p className="mb-0 fs-9 mt-1 text-body-secondary">
              Proc: {evtData.proc} | Tipo: {evtData.tipo_de_mto}
            </p>
          )}
        </div>
        <Button className="p-1 ms-auto" onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} className="fs-8" />
        </Button>
      </Modal.Header>
      
      <Modal.Body className="px-card pb-card pt-1 fs-9">
        {evtData?.texto && (
          <div className="mt-3 border-bottom border-translucent pb-3">
            <h5 className="mb-0 text-body-secondary">Detalle</h5>
            <p className="mb-0 mt-2">{evtData.texto}</p>
          </div>
        )}

        <div className={classNames('mt-4', { 'border-bottom border-translucent pb-3': evtData?.lugar })}>
          <h5 className="mb-0 text-body-secondary">Fecha y Hora</h5>
          <p className="mb-1 mt-2">
            {dayjs(selectedEvent?.start).format('dddd, D MMMM YYYY, h:mm A')}
            {selectedEvent?.end && ` – ${dayjs(selectedEvent.end).format('dddd, D MMMM YYYY, h:mm A')}`}
          </p>
        </div>

        {evtData?.lugar && (
          <div className="mt-4 border-bottom border-translucent pb-3">
            <h5 className="mb-0 text-body-secondary">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
              Lugar
            </h5>
            <p className="mb-0 mt-2">{evtData.lugar}</p>
          </div>
        )}

        {evtData?.usuario && (
          <div className="mt-4">
            <h5 className="mb-0 text-body-secondary">
              <FontAwesomeIcon icon={faUser} className="me-2" />
              Usuario
            </h5>
            <p className="mb-0 mt-2">{evtData.usuario}</p>
          </div>
        )}
      </Modal.Body>
      
      <Modal.Footer className="d-flex justify-content-end px-card pt-0 border-top-0">
        <Button
          onClick={handleRemove}
          variant="phoenix-danger"
          size="sm"
          startIcon={<FontAwesomeIcon icon={faTrash} className="fs-9" />}
        >
          Eliminar
        </Button>
        <Button
          onClick={handleEditClick}
          variant="primary"
          size="sm"
          endIcon={<FontAwesomeIcon icon={faPencilAlt} className="fs-10" />}
        >
          Editar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CalendarEventModal;